/**
 * Import the `createSlice` function from the `@reduxjs/toolkit` package.
 */
import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  /**
   * Represents a notification object with a name and initial state.
   * @param {{string}} name - The name of the notification.
   * @param {{object}} initialState - The initial state of the notification.
   */
  name: "notification",
  initialState: {},

  /**
   * Reducer functions for managing the notification list state.
   * @param {{object}} state - The current state object.
   * @param {{object}} action - The action object that contains the payload.
   * @returns None
   */
  reducers: {
    notificationList: (state, action) => {
      state.notification = action.payload;
    },

    editNotification: (state, action) => {
      state.notification = state?.notification?.map((item) => {
        if (item?._id === action.payload?._id) {
          return { ...item, title: action?.payload?.title };
        }

        return item;
      });
    },

    deleteNotification: (state, action) => {
      state.notification = state?.notification?.filter(
        (item) => item?._id !== action?.payload
      );
    },
  },
});

export const { notificationList, editNotification, deleteNotification } =
  notificationSlice.actions;

export default notificationSlice.reducer;
